import { useSelector } from "react-redux"
import { getUser } from "store/modules/common/auth"

const useUser = () => {
  return useSelector(getUser)
}

export default useUser
